import React, { useState } from 'react';
import {
  ModalActionContainer,
  ModalActionContent,
  ModalActionHead,
  ModalActionBody,
  ModalActionBodyIcon,
  ModalActionBodyLabel,
  ModalActionBodyDescription,
  ModalActionFooter,
  ModalActionFooterButton,
} from './styles';
import { Controller, useForm, useWatch } from 'react-hook-form';
import InputDefault from '../InputDefault';
import { Form, FormRow } from '../FormTemplate/styles';
import { IoClose } from 'react-icons/io5';
import colors from '../../assets/styles/colors';

const ModalActionText = ({ title, description, open, bodyIcon, rotateIcon, setShowModal, actionFunctionDownButton,
   actionLabelFunctionDownButton, backgroundIcon,enviar,campoRegister }) => {
    const { control, errors, handleSubmit, register, setValue } = useForm();
    const [comentario, setComentario] = useState('');
    const comentarioValue = useWatch({ control, name: 'comentario' });

  return (
    <ModalActionContainer open={open} id="modal-action">
      <ModalActionContent>
        <ModalActionHead  setShowModal={setShowModal}>    
          {setShowModal && <IoClose size={26} color={colors.textSecondary} onClick={() => setShowModal(false)} id="close-icon" />}    
        </ModalActionHead>
        <ModalActionBody>
          <ModalActionBodyIcon backgroundIcon={backgroundIcon} rotateIcon={rotateIcon}>
            {bodyIcon}
          </ModalActionBodyIcon>
          <ModalActionBodyLabel>
            {title}
          </ModalActionBodyLabel>
          {description && (
            <ModalActionBodyDescription>
              {description}
            </ModalActionBodyDescription>
          )}
        </ModalActionBody>
        <Form onSubmit={handleSubmit((data) => enviar(data.comentario))}>
            <FormRow col="1">
            <Controller
            as={InputDefault}
            control={control}
            label=''
            name="comentario"
            id="comentario"
            error={errors.comentario}
            value={comentario}
            register={campoRegister} />
            </FormRow>
        <ModalActionFooter>
          {actionFunctionDownButton && (
            <ModalActionFooterButton onClick={() => actionFunctionDownButton()} id="top-action-button">
              {actionLabelFunctionDownButton}
            </ModalActionFooterButton>
          )}
        </ModalActionFooter>
        </Form>
      </ModalActionContent>
    </ModalActionContainer>
  )
}

export default ModalActionText
